<script setup>
import { computed } from "vue";

const emit = defineEmits(["closed"]);
const props = defineProps({
  poolCandidateAssoc: {
    type: Object,
    required: true,
    default: () => {},
  },
});

const hasAreasOfInterest = computed(() => {
  return props.poolCandidateAssoc.areasOfInterest?.length > 0;
});

const hasPreferredLocations = computed(() => {
  return props.poolCandidateAssoc.preferredLocations?.length > 0;
});

function onClose() {
  emit("closed");
}
</script>

<template>
  <div id="pool-candidate-assoc">
    <div class="d-flex align-items-top justify-content-between">
      <div>
        <div>Joined at: <b>{{ poolCandidateAssoc.joinedAt }}</b></div>
        <div v-if="hasAreasOfInterest">
          Areas of interest: <b>{{ poolCandidateAssoc.areasOfInterest.join(', ') }}</b>
        </div>
        <div v-if="hasPreferredLocations">
          Preferred locations: <b>{{ poolCandidateAssoc.preferredLocations.join(', ') }}</b>
        </div>
      </div>

      <div>
        <span class="d-flex align-items-center">
          <router-link :to="{ name: 'job-root', params: { projectId: poolCandidateAssoc.projectId } }">
            <el-button type="secondary">
              View job
            </el-button>
          </router-link>

          <span
            class="material-icons-round text-color-black-50 ml-8 md-18 close-touchpoint"
            @click="onClose"
          >
            close
          </span>
        </span>
      </div>
    </div>
  </div>
</template>
